import dayjs from 'dayjs';

import { useAutoSave } from '../../hooks/useAutoSave';
import { useAppSelector } from '../../state';
import { LocalImage } from '../Image';
import { useTranslation } from 'next-i18next';

import { EWorkspaceNpcStatus } from '../../types/npc';
import { getNpcStatus, StatusIconMap } from '../Home/NpcList';
import { useMemo } from 'react';

const StatusTextMap: Record<EWorkspaceNpcStatus, string> = {
  [EWorkspaceNpcStatus.Draft]: 'draft',
  [EWorkspaceNpcStatus.Release]: 'edit_released',
  [EWorkspaceNpcStatus.ReviewFailed]: 'edit_reviewFailed',
  [EWorkspaceNpcStatus.UnderReview]: 'edit_underReview',
};

interface IDraftInfoProps {
  styles: Record<string, string>;
  userSaveTime: Date | null;
}

function formatTime(date: Date) {
  return dayjs(date).format('HH:mm:ss');
}

function getLatestDate(date1: Date | null, date2: Date | null): Date | null {
  if (date1 === null && date2 === null) {
    return null;
  }
  if (date1 === null) {
    return date2;
  }
  if (date2 === null) {
    return date1;
  }
  return date1 > date2 ? date1 : date2;
}

export function DraftInfo({ styles, userSaveTime }: IDraftInfoProps) {
  const { saveTime } = useAutoSave();
  const { settingInfo, statusInfo } = useAppSelector((state) => state.edit);
  const { t } = useTranslation();

  const status = getNpcStatus(statusInfo);

  const latestDate = useMemo(() => getLatestDate(saveTime, userSaveTime), [saveTime, userSaveTime]);
  return (
    <div className={styles.draftInfo}>
      <h3 className={styles.draftTitle}>{settingInfo.npc_name || t('edit_draft_title')}</h3>
      <section className={styles.draftMeta}>
        <LocalImage alt="icon" width="16" height="16" src={StatusIconMap[status]} />
        <div className={styles.draftStatus}>{t(StatusTextMap[status])}</div>
        <div className={styles.saveTime}>
          {latestDate ? `${t('auto_saved')} ${formatTime(latestDate)}` : ''}
        </div>
      </section>
    </div>
  );
}

export default DraftInfo;
